module.exports = __webpack_public_path__ + "static/media/orderDetail.00464ae4.png";